import { string, struct } from 'io-ts/Decoder';

export const QuotedMessage = struct({
	createdAt: string,
	createdBy: string,
	text: string,
});
